// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#coordzoomstatus-control {\n  display: inline;\n  position: absolute;\n  max-width: 500px;\n  height: 20px;\n  background: rgba(0,60,136,0.5);\n  bottom: 0;\n  right:0;\n  margin:auto;\n  margin-bottom: 9px;\n  margin-right: 9px;\n  border-radius: 4px;\n  text-align: center;\n  padding-right: 5px;\n}\n\n#coordzoomstatus-control span {\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
